import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';

const setGirdContentHeight = (cardsModule) => {
  const cards = cardsModule.getElementsByTagName('article');

  if (!cards.length) return;
  let maxHeight = 0;
  let maxWidth = 0;
  Array.from(cards)?.forEach((el) => {
    const currentElementHeight = el?.getBoundingClientRect();
    maxHeight = maxHeight > currentElementHeight.height ? maxHeight : currentElementHeight.height;
    maxWidth = maxWidth > currentElementHeight.width ? maxHeight : currentElementHeight.width;
  });

  Array.from(cards)?.forEach((el) => {
    el.style.height = `${maxHeight}px`;
    el.style.width = `${maxWidth}px`;
  });
};

const revertSection = (grid) => {
  if (!isMobileScreen(BREAKPOINTS.XL)) return;
  const parent = grid?.closest('.section_banner ');
  if (!parent?.classList?.contains('section_left_banner')) return;
  const bannerContainer = grid?.closest('.section_banners_container');

  if (!bannerContainer) return;
  bannerContainer.style.flexDirection = 'column-reverse';

};

const onGridWrapperLoad = () => {
  const gridWrapper = document.getElementsByClassName('grid-wrapper');

  if (!gridWrapper.length) return;

  Array.from(gridWrapper).forEach((item) => {
    setGirdContentHeight(item);
    revertSection(item);
  });

};

export default onGridWrapperLoad;
